import Api from '../api/Api';
import { getUserFromBFF } from '../api/User';

import User from '../models/User';

export const LOAD_USER = 'LOAD_USER';

export function loadUser(user) {
    return {
        type: LOAD_USER,
        payload: {
            [user.id]: new User(user)
        }
    };
}

export function loadUsers(users = []) {
    const userList = {};
    users.forEach((user) => {
        userList[user.id] = new User(user);
    });
    return {
        type: LOAD_USER,
        payload: userList
    };
}

export function fetchUser(id) {
    return async (dispatch) => {
        try {
            const user = await Api.User.getOne(id);
            let userFromBff = {};

            try {
                userFromBff = await getUserFromBFF(id);
            } catch (error) {
                console.error('Error fetching user from BFF:', error);
            }

            const { reactivity_level } = userFromBff;

            dispatch(loadUser({ ...user, reactivity_level }));
        } catch (error) {
            console.error('Error fetching user:', error);
        }
    };
}
